/* 카테고리 탭 — 페이지에 들어오면 **지금 보고 있는 카테고리**가 보이도록 줄을 옆으로 옮긴다.
 *
 * ⚠️ 이 줄은 가로 스크롤러다(내용 580 · 뷰포트 375). 활성 항목이 오른쪽 끝에 있으면
 *    사용자는 자기가 어느 카테고리에 있는지 못 보고 시작한다.
 * ⚠️⚠️ **`scrollIntoView` 를 쓰지 말 것** — 그 함수는 **페이지도 세로로 움직인다**.
 *    상단에서 들어왔는데 화면이 아래로 튀어 배너를 지나친다. `scrollLeft` 만 손댄다.
 * ⚠️ 활성 표시는 `aria-current="page"`(Liquid 의 `link.current`)다. 그게 없는 경우
 *    (메뉴에 없는 컬렉션으로 직접 들어온 경우)에는 경로로 찾는다.
 * ⚠️ `behavior: 'instant'` 다 — 랜딩 직후의 애니메이션은 사용자가 시작하지 않은 움직임이라
 *    화면이 저절로 흐르는 것처럼 보인다.
 */
(function () {
  if (window.__ntCats) return;
  window.__ntCats = true;

  function pathOf(href) {
    try {
      return new URL(href, window.location.origin).pathname.replace(/\/+$/, '');
    } catch (e) {
      return '';
    }
  }

  function center(nav) {
    if (nav.scrollWidth <= nav.clientWidth + 1) return; /* 넘치지 않으면 옮길 것이 없다 */

    var link = nav.querySelector('.ncc__link[aria-current="page"]');
    if (!link) {
      var here = pathOf(window.location.pathname);
      var links = nav.querySelectorAll('.ncc__link');
      for (var i = 0; i < links.length; i++) {
        if (pathOf(links[i].getAttribute('href')) === here) {
          link = links[i];
          break;
        }
      }
    }
    if (!link) return;

    /* 가능하면 가운데, 양 끝 항목이면 끝에 붙인다(가운데로 밀면 빈 자리가 생긴다). */
    var target = link.offsetLeft - (nav.clientWidth - link.offsetWidth) / 2;
    var max = nav.scrollWidth - nav.clientWidth;
    nav.scrollLeft = Math.max(0, Math.min(max, target));
  }

  /* ── 좌우 화살표 — 카페24 `.nav-prev` / `.nav-next` 이식 ──────────────
   * 원본(`/product/list.html` 인라인 스크립트) 동작:
   *   - 왼쪽 끝(`scrollLeft === 0`)이면 prev 숨김
   *   - 오른쪽 끝(`scrollLeft + clientWidth >= scrollWidth`)이면 next 숨김
   *   - 누르면 한 화면 폭만큼 부드럽게 민다
   *
   * ⚠️ 원본은 미는 양이 `window.innerWidth` 다. 여기서는 **줄의 폭**(`clientWidth`)을 쓴다 —
   *    이 줄은 화면 가득이라 값이 사실상 같고, 좌우 여백이 생겨도 줄 밖으로 튀지 않는다.
   * ⚠️ 표시 여부는 `data-visible` 속성이다. `style.display` 로 직접 쓰면 CSS 의
   *    미디어쿼리·상태 규칙과 어느 쪽이 이기는지 읽을 수 없게 된다.
   * ⚠️ `scrollWidth` 는 소수로 떨어질 수 있어 **1px 여유**를 둔다. 없으면 오른쪽 끝에서
   *    next 화살표가 사라지지 않고 남는다. */
  function arrowsOf(nav) {
    var wrap = nav.closest('.ncc-wrap');
    if (!wrap) return null;
    var prev = wrap.querySelector('[data-ncc-arrow="prev"]');
    var next = wrap.querySelector('[data-ncc-arrow="next"]');
    if (!prev || !next) return null;
    return { prev: prev, next: next };
  }

  function syncArrows(nav) {
    var a = arrowsOf(nav);
    if (!a) return;

    var max = nav.scrollWidth - nav.clientWidth;
    /* 넘치지 않으면 둘 다 감춘다 — 눌러도 움직일 것이 없다. */
    if (max <= 1) {
      a.prev.setAttribute('data-visible', '0');
      a.next.setAttribute('data-visible', '0');
      return;
    }
    a.prev.setAttribute('data-visible', nav.scrollLeft > 1 ? '1' : '0');
    a.next.setAttribute('data-visible', nav.scrollLeft < max - 1 ? '1' : '0');
  }

  function wireArrows(nav) {
    if (nav.__ntArrows) return;
    var a = arrowsOf(nav);
    if (!a) return;
    nav.__ntArrows = true;

    var reduce =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var push = function (dir) {
      var max = nav.scrollWidth - nav.clientWidth;
      var from = nav.scrollLeft;
      var target = Math.max(0, Math.min(max, from + dir * nav.clientWidth));

      nav.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' });
      if (reduce) return;

      /* ⚠️⚠️ **`behavior: 'smooth'` 가 무시되는 환경이 있다 — 폴백을 지우지 말 것.**
         라이브 실측(375, 모바일 에뮬레이션): 같은 요소에 `behavior: 'auto'` 는 56px 움직였는데
         `'smooth'` 는 **0px**, 즉 화살표를 눌러도 아무 일도 일어나지 않았다.
         부드러운 이동이 실제로 시작됐으면 한 프레임 안에 몇 px 은 움직인다 — 120ms 뒤에도
         제자리면 애니메이션이 안 도는 환경이므로 즉시 이동으로 되돌린다.
         ⚠️ 임계값을 0 으로 두지 말 것 — 서브픽셀 때문에 정상 동작에서도 걸린다. */
      window.setTimeout(function () {
        if (Math.abs(nav.scrollLeft - from) < 1) nav.scrollLeft = target;
      }, 120);
    };

    a.prev.addEventListener('click', function () {
      push(-1);
    });
    a.next.addEventListener('click', function () {
      push(1);
    });

    nav.addEventListener('scroll', function () {
      syncArrows(nav);
    }, { passive: true });
  }

  function init() {
    document.querySelectorAll('nav.ncc').forEach(function (nav) {
      center(nav);
      wireArrows(nav);
      syncArrows(nav);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* 글꼴이 늦게 오면 항목 폭이 바뀐다 — 그때 한 번 더 맞춘다. */
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(init);
  document.addEventListener('shopify:section:load', init);

  /* ⚠️ 폭이 바뀌면 넘치는지 여부가 바뀐다 — 화살표만 다시 판정한다.
     `center()` 까지 다시 부르면 사용자가 밀어 둔 위치가 되돌아간다. */
  window.addEventListener('resize', function () {
    document.querySelectorAll('nav.ncc').forEach(syncArrows);
  });
})();
